import React from 'react';

import { ObjectListFlyoutEmptyState } from './object-list-flyout-empty-state';
import { ObjectListStarredEmptyState } from './starred-empty-state';

export type NavFlyoutEmptyStateProps = {
	variant?: 'default' | 'starred';
};

export function NavFlyoutEmptyState({
	variant = 'default',
}: NavFlyoutEmptyStateProps): React.JSX.Element {
	return variant === 'starred' ? <ObjectListStarredEmptyState /> : <ObjectListFlyoutEmptyState />;
}
